import { useBottomSheet } from '@croquiscom-pvt/zds';

import { useZigzag } from '@common/device-manager';

import { PurchaseHistoryCardCarousel } from './PurchaseHistoryCardCarousel';
import { PurchaseHistoryCardList } from './PurchaseHistoryCardList';
import { PurchaseHistoryCardItem } from './types';

export interface PurchaseHistoryCardContainerProps {
  items: PurchaseHistoryCardItem[];
  selectedId: string | null;
  /** 카드의 버튼(비교하기) 클릭 시 호출 - uniqueKey 전달. false 반환 시 바텀시트 닫지 않음 */
  onSelect: (item: PurchaseHistoryCardItem, uniqueKey: string) => boolean | void;
  /** 카드 영역(상품) 클릭 시 호출 */
  onProductClick: (item: PurchaseHistoryCardItem) => void;
  /** 앱 환경에서 더보기 클릭 시 호출될 외부 핸들러 (옵션) */
  onMoreClick?: () => void;
  maxVisibleItems?: number;
  /** 선택 전 버튼 텍스트 (기본값: '비교하기') */
  actionButtonText?: string;
  /** 선택 후 버튼 텍스트 (기본값: '비교 중') */
  selectedButtonText?: string;
  /** 바텀시트 타이틀 (기본값: '비교할 상품을 선택해 주세요') */
  bottomSheetTitle?: string;
}

export const PurchaseHistoryCardContainer = ({
  items,
  selectedId,
  onSelect,
  onProductClick,
  onMoreClick,
  maxVisibleItems = 5,
  actionButtonText = '비교하기',
  selectedButtonText = '비교 중',
  bottomSheetTitle = '비교할 상품을 선택해 주세요',
}: PurchaseHistoryCardContainerProps) => {
  const isZigzagApp = useZigzag();
  const { open, close } = useBottomSheet('custom');

  const handleCardClick = (uniqueKey: string) => {
    const item = items.find((i) => i.uniqueKey === uniqueKey);
    if (item) {
      onSelect(item, uniqueKey);
    }
  };

  const handleProductClick = (uniqueKey: string) => {
    const item = items.find((i) => i.uniqueKey === uniqueKey);
    if (item) {
      onProductClick(item);
    }
  };

  const handleMoreClick = () => {
    if (isZigzagApp && onMoreClick) {
      onMoreClick();
    } else {
      open({
        children: (
          <PurchaseHistoryCardList
            title={bottomSheetTitle}
            items={items}
            selectedId={selectedId}
            onCardClick={(item, uniqueKey) => {
              const shouldClose = onSelect(item, uniqueKey);
              if (shouldClose !== false) {
                close();
              }
            }}
            onProductClick={(item) => {
              onProductClick(item);

              close();
            }}
            onClose={() => {
              close();
            }}
            actionButtonText={actionButtonText}
            selectedButtonText={selectedButtonText}
          />
        ),
      });
    }
  };

  return (
    <PurchaseHistoryCardCarousel
      items={items}
      selectedId={selectedId}
      onCardClick={handleCardClick}
      onProductClick={handleProductClick}
      onMoreClick={handleMoreClick}
      maxVisibleItems={maxVisibleItems}
      actionButtonText={actionButtonText}
      selectedButtonText={selectedButtonText}
    />
  );
};
